import { writable } from 'svelte/store'

// Función para normalizar la ruta (remover /ui/ si está presente)
function normalizePath(path: string): string {
  if (!path) return '/'
  // Si la ruta empieza con /ui/, removerlo
  if (path.startsWith('/ui/')) {
    const normalized = path.slice(4) || '/'
    return normalized
  }
  // Si es solo /ui, convertir a /
  if (path === '/ui') {
    return '/'
  }
  return path
}

// Obtener la ruta inicial
function getInitialPath(): string {
  if (typeof window === 'undefined') return '/'
  return normalizePath(window.location.pathname)
}

// Inicializar con la ruta actual normalizada
export const currentRoute = writable(getInitialPath())

export function navigate(path: string) {
  // Asegurar que la ruta empiece con /
  const normalizedPath = path.startsWith('/') ? path : '/' + path
  
  // Construir la URL completa para el navegador
  // Si la app está bajo /ui/, mantenerlo
  const currentBase = typeof window !== 'undefined' && window.location.pathname.startsWith('/ui/') ? '/ui' : ''
  const fullPath = currentBase + normalizedPath
  
  if (typeof window !== 'undefined') {
    window.history.pushState({}, '', fullPath)
  }
  currentRoute.set(normalizedPath)
}

// Listen to browser back/forward
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    currentRoute.set(normalizePath(window.location.pathname))
  })
}
